export default __webpack_public_path__ + "static/media/COPD-Stable-2.1c69923f.jpg";